import { BROADCAST_OVERLAY_STALE_AFTER_MS } from '@qaytim/shared';

export type OverlayPresence =
  { state: 'never' } | { state: 'live'; agoMs: number } | { state: 'stale'; agoMs: number };

/**
 * OBS manbasining holati — sof funksiya, chunki uni hukm qiladigan qoida efirda muhim va uni
 * komponentdan tashqarida sinash kerak.
 *
 * `never` va `stale` ni AJRATISH ataylab: "hali ulanmagan" — repetisiyagacha normal holat,
 * "javob bermayapti" esa efir o'rtasida buzilish. Ikkalasini bitta qizil belgiga qo'shib
 * yuborish operatorga har efir boshida yolg'on signal berardi va u belgiga ishonmay qo'yardi.
 *
 * Kirish qiymati — SANA EMAS, YOSH. Serverdan `overlayAgeMs` yoshi keladi, konsol esa unga javob
 * kelganidan beri o'tgan vaqtni qo'shadi. Ikkala qo'shiluvchi ham ayirma bo'lgani uchun hukm
 * server va brauzer soatlari farqidan mustaqil; mutlaq sana solishtirilganida esa 5 soniyalik
 * chegara o'sha farqni to'g'ridan-to'g'ri yutardi (sabab `adminDrawDetailSchema.overlayAgeMs` da).
 */
export function overlayPresence(ageMs: number | null): OverlayPresence {
  if (ageMs === null || !Number.isFinite(ageMs)) return { state: 'never' };

  // Manfiy yosh ma'nosiz — brauzer soati javob kelgandan keyin orqaga surilgan bo'lishi mumkin.
  const clamped = Math.max(0, ageMs);
  return clamped <= BROADCAST_OVERLAY_STALE_AFTER_MS
    ? { state: 'live', agoMs: clamped }
    : { state: 'stale', agoMs: clamped };
}

/** `agoMs` ni operator o'qiydigan songa aylantiradi: soniya, bir daqiqadan oshsa daqiqa. */
export function presenceAgo(agoMs: number): { value: number; unit: 'seconds' | 'minutes' } {
  const seconds = Math.floor(agoMs / 1000);
  return seconds < 60
    ? { value: seconds, unit: 'seconds' }
    : { value: Math.floor(seconds / 60), unit: 'minutes' };
}
